import { ImageUploader } from "@/components/ui";

/**
 * MediaStep - Step 4: Image upload
 */
const MediaStep = ({ imageState, setImageState }) => {
    return (
        <ImageUploader
            images={imageState.items}
            onChange={(newItems) =>
                setImageState((prev) => ({
                    ...prev,
                    items: newItems,
                }))
            }
            onDelete={(deletedItem) => {
                // Only track existing server images for deletion
                if (deletedItem.isExisting && deletedItem.id) {
                    setImageState((prev) => ({
                        ...prev,
                        deleted: [...prev.deleted, deletedItem.id],
                    }));
                }
            }}
            maxImages={5}
            label="Foto Produk"
            description="Upload hingga 5 foto produk. Format: JPG, PNG. Max 2MB per file."
        />
    );
};

export default MediaStep;
